import { ChangeEvent } from 'react';
import styled, { css } from 'styled-components';

import Input, { InputProps } from 'design-system/components/Input';
import inputMixin from 'design-system/mixins/input';

const StyledContainer = styled.div`
  display: inline-block;
  position: relative;
`;

const sharedStyles = css`
  margin: 0;
  padding: 2px 10px;
`;

const StyledSpan = styled.span`
  ${inputMixin}
  ${sharedStyles}
  padding-right: 20px;
  display: inline-block;
  visibility: hidden;
  white-space: pre;
`;

const StyledInput = styled(Input)`
  ${sharedStyles}
  background-color: ${({ theme }) => theme.color.background.primary};
  color: ${({ theme }) => theme.color.text.primary};
  &:not(:focus) {
    border-style: none;
  }
  &:hover:not(&:disabled) {
    border-style: solid;
  }
`;

const InputWrapper = styled.div`
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

export interface DynamicInputProps {
  value?: string;
  dataTest?: string;
  disabled?: boolean;
  onBlur?: () => void;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

const DynamicInput = ({
  value,
  onChange,
  onBlur,
  disabled = false,
  dataTest = '',
  size = 'md',
  ...props
}: DynamicInputProps & InputProps) => {
  return (
    <StyledContainer>
      <StyledSpan className='text'>{value}</StyledSpan>
      <InputWrapper>
        <StyledInput
          aria-label={props['aria-label'] ?? 'Edit'}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          data-test={dataTest}
          disabled={disabled}
          size={size}
        />
      </InputWrapper>
    </StyledContainer>
  );
};

export default DynamicInput;
